import { Capacitor } from "@capacitor/core";

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function webDownloadTargets(userAgent = navigator.userAgent) {
  if (isNativeApp()) return [];
  const ua = String(userAgent || "").toLowerCase();
  const ios = /iphone|ipad|ipod/.test(ua);
  const android = /android/.test(ua);
  const targets = {
    ios: {
      key: "ios",
      label: "Scarica per Apple",
      url: process.env.REACT_APP_IOS_APP_URL || "",
    },
    android: {
      key: "android",
      label: "Scarica per Android",
      url: process.env.REACT_APP_ANDROID_APP_URL || "",
    },
  };
  if (ios) return [targets.ios, targets.android];
  if (android) return [targets.android, targets.ios];
  return [targets.ios, targets.android];
}
